import React from 'react';

interface StockWeightFieldsProps {
  stock: number;
  weight: number;
  errors: {
    stock?: string;
    weight?: string;
  };
  onChange: (field: 'stock' | 'weight', value: number) => void;
}

const StockWeightFields: React.FC<StockWeightFieldsProps> = ({
  stock,
  errors,
  onChange
}) => {
  return (
    <>
      <div className='col-span-2'>
        <label className="block text-xs font-bold uppercase tracking-wider text-tinta">
          Estoque *
        </label>
        <input
          type="tel"
          value={stock}
          onChange={(e) => onChange('stock', parseInt(e.target.value) || 0)}
          className={`mt-1 block w-full bg-white border rounded-lg px-3 py-2.5 text-sm text-tinta focus:outline-none focus:ring-2 transition-colors ${
            errors.stock
              ? 'border-bordo/60 focus:ring-bordo/40 focus:border-bordo'
              : 'border-tinta/15 focus:ring-bordo/40 focus:border-bordo'
          }`}
        />
        {errors.stock && (
          <p className="mt-1 text-sm text-bordo italic">{errors.stock}</p>
        )}
        <p className="mt-1 text-xs text-tinta-soft italic">
          Defina a quantidade disponível deste produto. Para produtos marcados como "Não foi dessa vez", o estoque é ilimitado.
        </p>
      </div>
    </>
  );
};

export default StockWeightFields;
